// On-surface sacrifice-and-draw pure helper. No React, no Three.js.
//
// ── Codex (Buried Treasure / Sunken Treasure, Artifact. Relic) ──
//   "If cast, conjure this under an allied land/water site of an
//    opponent's choice. When carried to the surface, its controller
//    sacrifices it and draws two cards."
//
// on_surface trigger. Fires the moment the buried/submerged Relic is
// carried up to the surface (region transition to null). This op
// resolves the surface clause: the controller draws args.draw.amount
// spells, THEN the source sacrifices itself.
//
// Order matters: the draw resolves BEFORE the sacrifice so the
// controller is read off the still-in-play card and the source's mesh
// is still present when the draw funnel runs.
//
// Host adapter contract (already on host._silentOpsHost):
//   drawSpellsFor(controller, count): number. Draws `count` spells
//     into `controller`'s hand; returns how many were drawn.
//   sendToCemetery(card): void. The synced sacrifice primitive
//     (sendCardToPile → Cemetery).
//   logAction(key, values?): void

import { msg } from '../../../logMessage';

/**
 * Resolve Buried Treasure / Sunken Treasure's on-surface clause.
 *
 * @param {object} sourceCard
 * @param {object} args  { draw: { amount?, source?: 'spell' | 'site' | 'card' } }
 * @param {object} host
 */
export function applySacrificeSelfDraw(sourceCard, args, host) {
  const controller = sourceCard.rotated ? 'p2' : 'p1';
  const count = args?.draw?.amount ?? 2;
  const drawn = host.drawSpellsFor(controller, count, args?.draw?.source);
  host.logAction(
    '{source} surfaces. {who} draws {n} and sacrifices it',
    {
      source: sourceCard.name || msg('Relic'),
      who: controller === 'p1' ? msg('Player 1') : msg('Player 2'),
      n: drawn,
    },
  );
  host.sendToCemetery(sourceCard);
}
